module.exports = {"pathContext":{"name":"CouponProductInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":"false","description":null,"name":"autoApply","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-coupon-product-input.json
// module id = 1396
// module chunks = 13875959300118